import { useContext, useState, useEffect } from 'react';

//context
import { UserContext } from '../context/userContext';
import { ComponentContext } from '../context/componentContext';
import { AuthContext } from '../context/authContext';

// import { useSessionState, useLocalState } from '../utils/useStorageHooks';

export const useProfile = () => {
  const { menuOpen, reload, unexpectedError, setUnexpectedError, setLoading } = useContext(
    ComponentContext
  );
  const { session, setSession } = useContext(AuthContext);
  const { getProfile, updateProfile } = useContext(UserContext);

  const [profile, setProfile] = useState({});
  const [unmountSetup, setUnmountSetup] = useState(false);

  // const [sessionJWT, setSessionJWT] = useSessionState('jwt', true);
  // const [localJWT, setLocalJWT] = useLocalState('jwt', true);

  useEffect(() => {
    let mounted = true;
    if (session) {
      (async () => {
        setLoading(true);
        try {
          const profile = await getProfile();
          if (mounted) {
            if (profile.code === 200) {
              setProfile(profile.data);
              // if (sessionJWT) {
              //   setSessionJWT({ token: sessionJWT.token, user: profile.data });
              // }
              // if (localJWT) {
              //   setLocalJWT({ token: localJWT.token, user: profile.data });
              // }
            } else {
              setUnexpectedError('Unexpected Server Error!');
            }
          }
        } catch (error) {
          if (error && error.status === 401) setSession(false);
          else {
            setUnexpectedError('Unexpected Network Error!');
          }
        }
        setLoading(false);
      })();
    }
    return () => (mounted = false);
  }, [reload, getProfile, session, setLoading, setSession, setUnexpectedError]);

  return {
    profile,
    unmountSetup,
    updateProfile,
    setProfile,
    unexpectedError,
    setUnexpectedError,
    menuOpen,
    setUnmountSetup,
    setSession
  };
};
